import cx from 'classnames';
import { Infinity, NotEqual } from 'education-icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useMeasure } from 'react-use';

import { useRobotSelector } from '../context';
import { monospace } from '../font';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import styles from './robot__error.module.scss';
import { useSyntaxError } from './useSyntaxError';

// eslint-disable-next-line no-shadow
enum RobotErrorType {
    SYNTAX,
    TIMEOUT,
}

const ERROR_MAP = {
    [RobotErrorType.TIMEOUT]: {
        Icon: Infinity,
        errorId: 'robot.errors.timeout',
    },
    [RobotErrorType.SYNTAX]: {
        Icon: NotEqual,
        errorId: 'robot.syntaxError',
    },
};

const ERROR_MSG_TYPE_MAP: { [index: string]: RobotErrorType } = {
    'Timeout expired running job': RobotErrorType.TIMEOUT, // Старый формат для обратной совместимости
    CodeCompletionTimeout: RobotErrorType.TIMEOUT,
    YandexCloudTimeoutException: RobotErrorType.TIMEOUT,
    RpsLimitExceededException: RobotErrorType.SYNTAX,
    SyntaxError: RobotErrorType.SYNTAX,
    IndentationException: RobotErrorType.SYNTAX,
    UnknownException: RobotErrorType.SYNTAX,
};

function getError(error: string) {
    const e = error.split(':');
    const errorType: string = e[0];
    let errorMessage = '';
    if (e.length > 1) {
        errorMessage = e.slice(1).join(':');
    }
    if (errorType in ERROR_MSG_TYPE_MAP) {
        return { errorMessage: errorMessage, errorType: ERROR_MSG_TYPE_MAP[errorType] };
    }
    return { errorMessage: errorMessage, errorType: RobotErrorType.SYNTAX };
}

const HIDE_WIDTH = 400;

/**
 * Ошибка в коде, отображается над кодом
 */
const RobotError = ({ className }: { className?: string }) => {
    const results = useRobotSelector((s) => s.state?.results);
    const attempt = useRobotSelector((s) => s.attempt);
    const error = useSyntaxError(results, attempt?.markers);

    const [ref, bounds] = useMeasure<HTMLDivElement>();

    if (!error) {
        return null;
    }

    const showIcon = bounds.width > HIDE_WIDTH;
    const { errorType } = getError(error);
    const errorId = ERROR_MAP[errorType].errorId;
    const Icon = ERROR_MAP[errorType].Icon;

    return (
        <div className={cx(styles.error, className, monospace)} ref={ref} title={error}>
            {showIcon && <Icon className={styles.error__icon} />}
            <FormattedMessage id={errorId} />
        </div>
    );
};

export default RobotError;
